import { Component } from '@angular/core';
import * as myGlobals from './globals';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'hr4141';
  crs = myGlobals.CRS;
}
